"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@focaltec-suite/core");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _validators = require("../validators");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function AnyAutocomplete(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'outlined' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$margin = _ref.margin,
    margin = _ref$margin === void 0 ? 'dense' : _ref$margin,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
    name = _ref.name,
    initialValue = _ref.initialValue,
    startAdornment = _ref.startAdornment,
    endAdornment = _ref.endAdornment,
    label = _ref.label,
    options = _ref.options,
    grouped = _ref.grouped,
    required = _ref.required,
    disabled = _ref.disabled,
    freeSolo = _ref.freeSolo,
    _ref$prefillWhenSingl = _ref.prefillWhenSingle,
    prefillWhenSingle = _ref$prefillWhenSingl === void 0 ? true : _ref$prefillWhenSingl,
    register = _ref.register,
    notifier = _ref.notifier;
  var _useState = (0, _react.useState)(function () {
      var _a;
      return (_a = options.find(function (el) {
        return el.value === initialValue;
      })) !== null && _a !== void 0 ? _a : null;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)(initialValue !== null && initialValue !== void 0 ? initialValue : ''),
    _useState4 = _slicedToArray(_useState3, 2),
    rawValue = _useState4[0],
    setRawValue = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    blured = _useState6[0],
    setBlured = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    valid = _useState8[0],
    setValid = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    dirty = _useState10[0],
    setDirty = _useState10[1];
  var _useState11 = (0, _react.useState)(),
    _useState12 = _slicedToArray(_useState11, 2),
    error = _useState12[0],
    setError = _useState12[1];
  var ref = (0, _react.useRef)({
    valid: valid,
    dirty: dirty,
    value: rawValue,
    setBlur: function setBlur() {
      return setBlured(true);
    }
  });
  var onChange = function onChange(event, value, reason) {
    setDirty(true);
    switch (reason) {
      case 'selectOption':
        if (typeof value === 'string') {
          setValue({
            value: value,
            label: value
          });
        } else {
          setValue(value);
        }
        break;
      case 'clear':
        setBlured(true);
        setValue(null);
        break;
      case 'blur':
        setBlured(true);
        break;
      case 'createOption':
        var asString = value;
        setValue({
          value: asString,
          label: asString
        });
        break;
      default:
    }
  };
  var onInputChange = (0, _react.useCallback)(function (event, value, reason) {
    if (reason === 'input') {
      setValue({
        value: value,
        label: value
      });
    }
  }, []);
  var onNotify = (0, _react.useCallback)(function (value) {
    if (notifier) {
      notifier(name, value);
    }
  }, [notifier, name]);
  (0, _react.useEffect)(function () {
    var _a;
    var rawValue = (_a = value === null || value === void 0 ? void 0 : value.value) !== null && _a !== void 0 ? _a : '';
    var valid = !required || _validators.TEXT_REQUIRED_VALIDATOR.isValid(rawValue);
    var error = valid ? undefined : _validators.TEXT_REQUIRED_VALIDATOR.getMessage();
    ref.current.valid = valid;
    ref.current.dirty = dirty;
    ref.current.value = rawValue;
    setValid(valid);
    setError(error);
    setRawValue(rawValue);
    onNotify(rawValue);
  }, [value, dirty, required, onNotify]);
  (0, _react.useEffect)(function () {
    register(name, ref.current);
  }, [register, name, ref]);
  var freeSoloCallback = (0, _react.useCallback)(function (value) {
    if (value || !initialValue) return value;
    var currentOption = options.find(function (el) {
      return el.value === initialValue;
    });
    if (currentOption) {
      return value;
    }
    return {
      value: initialValue,
      label: initialValue
    };
  }, [initialValue, options]);
  var selectCallback = (0, _react.useCallback)(function (value) {
    if (initialValue) {
      var currentValue = options.find(function (el) {
        return el.value === (value === null || value === void 0 ? void 0 : value.value);
      });
      if (currentValue && currentValue.value === initialValue) {
        return value;
      }
    }
    var initial = options.find(function (el) {
      return el.value === initialValue;
    });
    if (initial) {
      return initial;
    }
    if (options.length === 1 && prefillWhenSingle) {
      return options[0];
    }
    return null;
  }, [options, initialValue, prefillWhenSingle]);
  (0, _react.useEffect)(function () {
    if (freeSolo) {
      setValue(freeSoloCallback);
    } else {
      setValue(selectCallback);
    }
  }, [freeSolo, freeSoloCallback, selectCallback]);
  var getOptionLabel = (0, _react.useCallback)(function (option) {
    if (typeof option === 'string') {
      return option || '---';
    }
    return (option === null || option === void 0 ? void 0 : option.label) || '---';
  }, []);
  var calculateInputProps = (0, _react.useCallback)(function (params) {
    if (startAdornment && endAdornment) {
      return Object.assign(Object.assign({}, params.InputProps), {
        startAdornment: startAdornment,
        endAdornment: endAdornment
      });
    }
    if (startAdornment) {
      return Object.assign(Object.assign({}, params.InputProps), {
        startAdornment: startAdornment
      });
    }
    if (endAdornment) {
      return Object.assign(Object.assign({}, params.InputProps), {
        endAdornment: endAdornment
      });
    }
    return params.InputProps;
  }, [startAdornment, endAdornment]);
  return /*#__PURE__*/_react["default"].createElement(_material.Autocomplete, {
    value: value,
    options: options,
    groupBy: grouped ? function (option) {
      var _a;
      return (_a = option.group) !== null && _a !== void 0 ? _a : '';
    } : undefined,
    getOptionLabel: getOptionLabel,
    fullWidth: fullWidth,
    onChange: onChange,
    onInputChange: freeSolo ? onInputChange : undefined,
    clearText: (0, _core.translate)('buttons.clear'),
    closeText: (0, _core.translate)('buttons.close'),
    openText: (0, _core.translate)('buttons.open'),
    noOptionsText: (0, _core.translate)('no_values'),
    disabled: disabled,
    freeSolo: freeSolo,
    includeInputInList: freeSolo,
    blurOnSelect: !freeSolo,
    openOnFocus: !freeSolo,
    isOptionEqualToValue: function isOptionEqualToValue(option, value) {
      return (option === null || option === void 0 ? void 0 : option.value) === (value === null || value === void 0 ? void 0 : value.value);
    },
    renderOption: function renderOption(props, option) {
      return /*#__PURE__*/_react["default"].createElement("li", Object.assign({}, props, {
        key: option.value
      }), option.label);
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_material.TextField, Object.assign({}, params, {
        label: label,
        required: required,
        variant: variant,
        size: size,
        margin: margin,
        error: blured && !valid,
        helperText: blured ? error : '',
        InputProps: calculateInputProps(params)
      }));
    }
  });
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(AnyAutocomplete);